import styled from "styled-components";
import { ArenaHeaderButtonLabelCasino888MiniOrbitBox } from "./arena-header-button-label.casino888.mini-orbit.box";

export const ArenaHeaderButtonLabelSICisBox = styled(ArenaHeaderButtonLabelCasino888MiniOrbitBox)`
    ${({theme}) => theme.font.presets.light};        

    color: ${props => props.theme.colors.backgroundLight};
    letter-spacing: 0px;
`;